var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 14,
    viewBox: "0 0 14 14",
    width: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.1939 1.10179c.33013-.668921 1.28399-.668925 1.61412 0l1.52109 3.08205 3.40129.49423c.7381.10727 1.0329 1.01444.4987 1.53513l-2.4611 2.39904.581 3.38746c.1261.7353-.6456 1.2959-1.3059.9488l-3.04214-1.5994-3.04217 1.5994c-.66026.3471-1.43195-.2135-1.30585-.9488l.581-3.38746-2.461167-2.39904c-.534164-.52069-.239408-1.42786.498787-1.53513l3.40125-.49423z",
    fill: "#373f41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.c1dbaba03497f86dfa52790034318cec.svg";
export { ForwardRef as ReactComponent };